import dayjs from "dayjs";

import { BsSearch } from "react-icons/bs";
import { FaPrint } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import InputGroup from "react-bootstrap/InputGroup";

import { Option } from "@/@types/generics/Option";
import { User } from "@/@types/sintegrada/User";

import { SelectComponent } from "@/components/SelectComponent";
import { AgeGroup } from "@/components/sintegrada/AgeGroup";

type Props = {
	startDate: string;
	setStartDate: (startDate: string) => void;
	endDate: string;
	setEndDate: (endDate: string) => void;
	minAge: string;
	setMinAge: (minAge: string) => void;
	maxAge: string;
	setMaxAge: (maxAge: string) => void;
	professionalId?: string;
	setProfessionalId: (professionalId?: string) => void;
	professionals: User[];
	handleFilter: () => void;
	handlePrint: () => void;
};

export function RiskClassificationDashboardFilters({
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	minAge,
	setMinAge,
	maxAge,
	setMaxAge,
	setProfessionalId,
	professionals,
	handleFilter,
	handlePrint,
}: Readonly<Props>) {
	const professionalOptions = [
		{ name: "Todos os profissionais" } as User,
		...professionals.map((professional) => {
			return { id: professional.id, name: professional.name };
		}),
	].map((professional) => {
		return {
			label: professional.name,
			value: String(professional.id || ""),
		} as Option<string | undefined>;
	});

	return (
		<Form
			onSubmit={(event) => {
				event.preventDefault();
				handleFilter();
			}}
		>
			<div className="d-flex flex-column flex-md-row gap-4">
				<Col md={4} className="align-items-center mb-3">
					<Form.Label>Período</Form.Label>
					<div className="d-flex gap-3">
						<InputGroup>
							<Form.Control
								type="datetime-local"
								value={startDate}
								placeholder="Data inicial"
								min={dayjs()
									.subtract(2, "years")
									.startOf("day")
									.format("YYYY-MM-DDTHH:mm")}
								max={dayjs().endOf("day").format("YYYY-MM-DDTHH:mm")}
								onChange={(event) => setStartDate(event.target.value)}
							/>
						</InputGroup>
						<InputGroup>
							<Form.Control
								type="datetime-local"
								value={endDate}
								placeholder="data final"
								min={startDate}
								max={dayjs().endOf("day").format("YYYY-MM-DDTHH:mm")}
								onChange={(event) => setEndDate(event.target.value)}
							/>
						</InputGroup>
					</div>
				</Col>

				<Col md={2}>
					<AgeGroup
						minAge={minAge}
						maxAge={maxAge}
						handleChangeMinAge={(value) => setMinAge(value)}
						handleChangeMaxAge={(value) => setMaxAge(value)}
					/>
				</Col>
				
				<Col md={3} className="d-flex align-items-center mb-3">
					<InputGroup>
						<Form.Label>Profissional</Form.Label>
						<SelectComponent
							className="w-100"
							name="professional"
							options={professionalOptions}
							onChange={(event) => setProfessionalId((event as Option<string>).value)}
							defaultValue={{ value: "", label: "Escolha uma opção" }}
							noOptionsMessage={() => "nenhum resultado encontrado na pesquisa"}
						/>
					</InputGroup>
				</Col>
				<Col md={3} className="d-flex align-items-end gap-3 mb-3">
					<Button type="submit" className="text-nowrap">
						<BsSearch className="me-2" />
						Consultar
					</Button>
					<Button
						onClick={handlePrint}
						className="text-nowrap"
						variant="muted text-white"
					>
						<FaPrint className="me-2 text-white" />
						Imprimir
					</Button>
				</Col>
			</div>
		</Form>
	);
}
